import {React,useState,useEffect,useRef} from 'react'
import { Link } from 'react-router-dom';
import { convertCurrency } from '../../utils/convertCurrency';
import axios from 'axios';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import logo from '../../images/YALWAS_LOGO-removebg-preview (2).png'
import illus from '../../images/6617.jpg'
import euro from '../../images/euro.png'
import dz from '../../images/algerie.png'
import transfert from '../../images/transfert.png'
import transfService from '../../images/transfer.jpg'
import fidel from '../../images/fidel.jpg'
import online from '../../images/enligne.jpg'
import partenaire from '../../images/partenaire.jpg'


function Home() {
    const [amount, setAmount] = useState();
    const [result, setResult] = useState("0.00");
    const [Taux, setTaux] = useState();
    const [ErrMsg,setErrMsg]=useState('');

    const ButtonTr = useRef();
    const Resaux = useRef();
    

    
    useEffect(()=>
    {
        axios.get('https://express-43ry.onrender.com/ExpressTauxBank')
        .then((response) => {
          const value = response.data.exchange_rate;
          console.log(value)
          const Taux1 = parseFloat(value.replace(',', '.'));
          let roundedValue

          if(Taux1%1>=0.5)
          {roundedValue = Math.ceil(Taux1);}    
          else
          {roundedValue = Math.floor(Taux1);}
          setTaux(roundedValue) 
        })
        .catch((error) => console.error('Error fetching data:', error));
    },[amount]);

    const [hidden, setHidden] = useState(false)
    const handlesubmit = (e) => {
        e.preventDefault();
        if(amount<50 || amount>5000)
        {
            setErrMsg('Désolé ,Le montant doit être compris entre 50 € et 5000 €')
            setResult("0.00")
            
        }else
        { 
          setErrMsg('')
          Resultat(amount,Taux)
        }
    }

  

    const Resultat = (amount,Taux)=>{
            setResult(convertCurrency(amount,Taux))   
    }

    const handleSend=(e)=>
    {
       if(amount == null)
       {
           setErrMsg('Désolé ,Le montant doit être compris entre 50 € et 5000 €')
       }
       else if(result !=="0.00")
       {
        // ButtonTr.current.classList.add('hidden');
        // Resaux.current.classList.remove('hidden');
        setHidden(true)
       }
    }

    const handleRS=(e)=>{
      setTimeout(() => {
        // ButtonTr.current.classList.remove('hidden');
        // Resaux.current.classList.add('hidden');
        setHidden(false)

      }, 2000);
      
    }

  return (
    <>

    <Header/>

    <div className='flex flex-col items-center'>
    <span><img className='mt-[12px] w-[200px] h-[90px] bg-transparent' src={logo} alt='' /></span>
    <span className='z-10 ml-[10px] mt-[-35px]'>Bienvenue</span>
    </div>

    <div className='Container flex mt-[30px] md:flex-row-reverse justify-between flex-col '>
    <div className='text-center'>
    <p className='Young mr-5'>Transformez vos devises en dinars avec facilité grâce à notre convertisseur.</p>
    <div className='ContainerConv shadow-2xl shadow-grey flex flex-col justify-center items-center border border-solid border-black ml-[20px] mr-[20px] mb-[20px] mt-10  rounded-[5px] sm:w-[400px] lg:w-[550px] '>
    <form onSubmit={handlesubmit} id='convertiseur'>
        <div className='flex flex-row items-center mt-[50px] '>
        <input  className='cursor-pointer border-solid border-[2px] border-gray-200  hover:border-black px-[12px] py-[12px]' type='number' step='any' placeholder='Enter a number' onChange={(e)=>setAmount(e.target.value)}  required/>
        <span className='px-[10px] py-0 border-solid border-[2px] border-gray-200  hover:border-black'><img className='h-12 w-12' src={euro} alt='euro'/></span>
        </div>
        <div className='flex items-center justify-center'>
        <button type='submit' className='mt-[10px] mb-[10px] rounded-full bg-slate-400 p-2'><img className='w-9 h-9' src={transfert} alt='transfert'/></button> 
        </div>
        <div className='flex flex-row items-center mb-[10px]'>
        <span className='w-[210px] px-[90px] py-[12px] cursor-pointer border-solid border-[2px] border-gray-200 hover:border-black'>{result}</span><span className='px-[10px] py-0 border-solid border-[2px] border-gray-200  hover:border-black '><img className='w-12 h-12 ' src={dz} alt='dzd'/></span>
        </div>

      </form>
      {/* {hidden?<h1>hello</h1> : <h1>world</h1>} */}
      <div>
      <div ref={ButtonTr} className={hidden?'hidden mt-[5px] mb-[10px]  ':'mt-[5px] mb-[10px]  '}>
      <button onClick={handleSend} className='px-[20px] py-[12px] bg-[#0C64C3] text-white rounded-[200px] text-center'>Transférer maintenant</button>
      </div>
       <div ref={Resaux} className={hidden?' mb-[13px]':' mb-[13px] hidden'}>
      <Link to="https://wa.me/213540139324" target="_blank"><button onClick={handleRS} className="bg-gray-100 text-green-600 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-5" type="button">
          <i className="fab fa-whatsapp-square text-2xl"></i></button></Link>
      <Link to="https://m.me/YALWAS" target="_blank"><button onClick={handleRS} className="bg-gray-100 text-messenger-blue shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-5" type="button">
          <i className="fab fa-facebook-messenger text-2xl"></i>
        </button></Link>
      <Link to="https://instagram.com/yalwas.offeciel" target="_blank"><button onClick={handleRS} className="cursor-pointer bg-gray-100 text-instagram-red shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-5" type="button">
          <i className="fab fa-instagram text-2xl"></i>
        </button></Link>
       
      </div>
      
      <div className='ml-[5px] mb-[10px]'>
        {ErrMsg && <div className='mt-[15px] text-red-500'>{ErrMsg}</div>}
      </div>
     
      </div>
    </div>
    </div>
    <div className='ContainerImg'>
    <img className='mt-[40px]  hidden md:block md: ml-[15px] md:w-[400px] md:h-[300px] lg:ml-[70px] lg:w-[450px] lg:h-[300px] ' src={illus} alt=''/>
    </div>
    </div>

    <div className='flex justify-center mt-10 mb-[10px] border-solid border-t border-black '>
      <h1 className='Young mt-[10px] text-[30px]'>Nos Service</h1>
    </div>

    <div className='ml-[10px] mr-[10px] flex  mt-5 justify-between flex-col md:flex-row'>

      <Link to='#' onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
       <div className='box1 border-solid  px-5 py-5 '>
        <h4 className='text-center font-bold'>Envoyer et Recevoir de l'argent en Euro</h4>
        <img className='w-[150] h-[100px] mx-auto' src={transfService} alt=''/>
        <p className='text-justify'>Transférez de l'argent en Euro en toute sécurité et rapidité grâce à notre plateforme conviviale. Facilitez le soutien financier à vos proches où qu'ils se trouvent.</p>
       </div>
      </Link>
      
      <Link to='http://m.me/YALWAS'>
       <div className='box2 border-solid  px-5 py-5'>
       <h4 className='text-center font-bold'>Paiement en Ligne des Factures</h4>
        <img className='w-[150] h-[100px] mx-auto' src={online} alt=''/>
        <p className='text-justify'>Réglez vos factures en ligne en quelques clics. Simplifiez vos paiements et évitez les tracas liés aux paiements en personne.</p>
       </div>
       </Link>

       <Link to='http://m.me/YALWAS'> 
       <div className='box3 border-solid  px-5 py-5'>
       <h4 className='text-center font-bold'>Fidélisation des Clients</h4>
        <img className='w-[200] h-[150px] mx-auto' src={fidel} alt=''/>
        <p className='text-justify mt-[-20px]'>Profitez de notre programme de fidélisation pour des avantages exclusifs. Gagnez des récompenses à chaque transaction et économisez sur vos frais de transfert.</p>
       </div>
       </Link>

       <Link to='http://m.me/YALWAS'> 
       <div className='box4 border-solid  px-5 py-5'>
       <h4 className='text-center font-bold'>Partenariats</h4>
        <img className='w-[150] h-[100px] mx-auto mt-[10px]' src={partenaire} alt=''/>
        <p className='text-justify'>Explorez des opportunités de partenariats pour étendre votre présence et offrir nos services à un public plus large. Devenez un partenaire YALWAS et bénéficiez de collaborations mutuellement avantageuses.</p>
       </div>
       </Link>
    </div>

    <Footer/>
    </>
  )
}

export default Home